import { buildMessage, registerDecorator, minDate } from 'class-validator';
import { DateTime } from 'luxon';
export const IS_DATE_TIME_GREATER_THAN_OR_EQUAL = 'isDateTimeGreaterThanOrEqual';
export function IsDateTimeGreaterThanOrEqual(property, options, validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            name: IS_DATE_TIME_GREATER_THAN_OR_EQUAL,
            target: object.constructor,
            propertyName: propertyName.toString(),
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(value, args) {
                    const [relatedPropertyName] = args.constraints;
                    const relatedValue = args.object[relatedPropertyName];
                    return (typeof value === 'string' &&
                        typeof relatedValue === 'string' &&
                        minDate(DateTime.fromFormat(value, options.format).toJSDate(), DateTime.fromFormat(relatedValue, options.format).toJSDate()));
                },
                defaultMessage: buildMessage((eachPrefix) => {
                    return `${eachPrefix}$property must be greater than or equal to ${property}`;
                }, validationOptions),
            },
        });
    };
}
//# sourceMappingURL=IsDateTimeGreaterThanOrEqual.js.map